import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { UseDosiminQueryOptions } from '~/components/Query/Query.hooks';

export const walletConnectionUrl = '/api/citizen/v1/csw/registered';

export type WalletType = 'DOSI_VAULT' | 'KAIKAS' | 'METAMASK';

export type WalletConnectionParams = {
  walletTypeList: WalletType[];
};

export type WalletConnection = {
  registered: boolean;
  sellerInfoUrl?: string;
  walletTypeList: WalletType[];
};

export const getWalletConnection = async (params?: WalletConnectionParams) => {
  const { data } = await axios.get<WalletConnection>(walletConnectionUrl, { params });
  return data;
};

export const useWalletConnection = (
  params?: WalletConnectionParams,
  options?: UseDosiminQueryOptions<WalletConnection>
) =>
  useQuery<WalletConnection>({
    queryKey: ['wallet', 'connection'],
    queryFn: () => getWalletConnection(params),
    initialData: {
      registered: false,
      walletTypeList: [],
    },
    ...options,
  });
